var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "smart-tv") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 18.125h-1c-0.006-5.313-4.312-9.619-9.625-9.625v-1c5.865 0.007 10.618 4.76 10.625 10.625zM18.875 18.125h-1c-0.004-3.657-2.968-6.621-6.625-6.625v-1c4.209 0.005 7.62 3.416 7.625 7.625zM15.875 18.125h-1c-0.002-2.001-1.624-3.623-3.625-3.625v-1c2.553 0.003 4.622 2.072 4.625 4.625zM7.373 18.755l0.707-0.707 0.707 0.707-0.707 0.707zM8.788 20.169l0.707-0.707 0.707 0.707-0.707 0.707zM5.959 20.169l0.707-0.707 0.707 0.707-0.707 0.707zM7.374 21.584l0.707-0.707 0.707 0.707-0.707 0.707zM4.545 21.583l0.707-0.707 0.707 0.707-0.707 0.707zM5.959 22.998l0.707-0.707 0.707 0.707-0.707 0.707zM3.131 22.998l0.707-0.707 0.707 0.707-0.707 0.707zM4.545 24.412l0.707-0.707 0.707 0.707-0.707 0.707zM32 22.5v-19h-32v19h0.8l-0.675 0.675 4.95 4.95 5.625-5.625h2.3v1.5c0 0.828-0.672 1.5-1.5 1.5h-0.5v3h10v-3h-0.5c-0.828 0-1.5-0.672-1.5-1.5v-1.5zM5.075 26.71l-3.535-3.535 6.718-6.718 3.535 3.535zM3 19.5v-13h26v13.008l-16.285-0.008-4.457-4.457-4.458 4.457zM20 26.5v1h-8v-1zM18.51 25.5h-5.020c0.33-0.431 0.509-0.958 0.51-1.5v-1.5h4v1.5c0.001 0.542 0.18 1.069 0.51 1.5zM11.7 21.5l1-1 17.3 0.008v-15.008h-28v15h0.8l-1 1h-0.8v-17h30v17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartTv);
export default __webpack_public_path__ + "static/media/smart-tv.015f70f56104d4e880028958273ea82a.svg";
export { ForwardRef as ReactComponent };